/* eslint-disable @angular-eslint/prefer-inject */
import { PurchaseOrderLineDataService } from '../infrastructure/purchase-order-lines/purchase-order-line.data.service';
import {
    PurchaseOrderLineCreate,
    PurchaseOrderLineDto,
    PurchaseOrderLineRead,
    PurchaseOrderLineSearchParams,
} from '../entities/purchase-order-line.dto';
import { PurchaseOrderLineStore } from '../infrastructure/purchase-order-lines/purchase-order-line.store';
import { Injectable } from '@angular/core';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { PurchaseOrderLineMapper } from '../infrastructure/purchase-order-lines/purchase-order-line.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { IManageEntityRoutes } from '@pf/shared-common';

@Injectable()
export class PurchaseOrderLineFacade extends AbstractManageEntityFacade<
    PurchaseOrderLineDto,
    PurchaseOrderLineRead,
    PurchaseOrderLineCreate,
    PurchaseOrderLineSearchParams
> {
    nameField: keyof PurchaseOrderLineDto = 'lineNumber';

    constructor(
        dataService: PurchaseOrderLineDataService,
        store: PurchaseOrderLineStore,
        mapper: PurchaseOrderLineMapper
    ) {
        super(
            dataService,
            null as unknown as IManageEntityRoutes,
            store,
            mapper
        );
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof PurchaseOrderLineDto, string>> {
        return { lineNumber: searchText };
    }
}
